import { Dialog, Grid, Icon, Typography } from '@material-ui/core'
import React, { useState, useEffect } from 'react'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { PostDataAPI } from '../../../../Services/APIService';
import { formatDate, formateMdnNumber } from '../../../../components/Common/Extensions';
import Loader from '../../../../components/Loader/Loader';
import { Label, DraggableComponent } from '../../../../components/UiElements/UiElements'

import DialogLoader from '../../../../components/Loader/DialogLoader';

function LineDetailsDialog({ dialogOpenClose, handleClose, isPrepaid, wirelessId, ...props }) {
    const classes = useStyles();
    const [accountNumber, setAccountNumber] = useState(props.accountNumber);
    const [mdnNumber, setMdnNumber] = useState(props.mdnNumber);
    const [lineDetails, setLineDetails] = useState({});//props.lineDetails
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({});
    const [iccNumber, setIccNumber] = useState(props.iCCNumber);

    const getLineInformationByMDN = () => {
        var obj = {
            wirelessId: wirelessId,
            MDN: mdnNumber,
            accountNumber: accountNumber,
            isPrepaid: isPrepaid,
            iCC: iccNumber
        };
        setIsLoading(true)
        PostDataAPI("telispire/getLineInformationByICC", obj, true).then((result) => {
            setIsLoading(false)
            if (result.success && result.data != null) {
                console.log(result.data);
                if (result.data.status == 1) {
                    result.data.status = "InActive";
                }
                else if (result.data.status == 2) {
                    result.data.status = "Active";
                }
                else if (result.data.status == 3) {
                    result.data.status = "Suspended";
                }
                else if (result.data.status == 4) {
                    result.data.status = "Disconnected";
                }
                else if (result.data.status == 6) {
                    result.data.status = "Hotlined";
                }
                else if (result.data.status == 7) {
                    result.data.status = "Rejected";
                }
                result.data.lineType = result.data.isPrepaid ? 'Prepaid' : 'Postpaid'
                setLineDetails(result.data);
            } else {

            }
        })
    }
    useEffect(() => {
        console.log(props.lineDetails)
        getLineInformationByMDN();
    }, []);
    return (
        <>

            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableBackdropClick
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="lg"
                PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
                {...props} >
                <div className={classes.dialogContent}>

                    <div className={classes.box}>

                        <div className={classes.header} id="draggable-dialog-title">
                            {/* <FormGroupTitle>Figgers Coverage</FormGroupTitle> */}
                            <Typography className={classes.title}>Line Details: {formateMdnNumber(props.mdnNumber)}</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                            {/* <span className={classes.crossButton} onClick={handleClose}><img src={CloseIcon} alt="close" /></span> */}
                        </div>
                        {isLoading ? <DialogLoader></DialogLoader> : ''}
                        <div className={classes.content}>


                            <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={600}>
                                <Grid container row>
                                    <Grid item lg={6}>
                                        <Grid row lg={12}>
                                            <Typography className={classes.labelText}>Name:</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid item lg={6}>
                                        <Grid row lg={12}>
                                            <Typography className={classes.labelText}>Plan Name:</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid item lg={6}>
                                        <Grid row lg={12}>
                                            <Typography className={classes.valueText}>{lineDetails.username}</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid item lg={6}>

                                        <Grid row lg={12}>
                                            <Typography className={classes.valueText}>{lineDetails.planDisplayName}</Typography>
                                        </Grid>

                                    </Grid>

                                    <Grid item lg={6}>

                                        <Grid row lg={12}>
                                            <Typography className={classes.labelText}>Type:</Typography>
                                        </Grid>

                                    </Grid>

                                    <Grid item lg={6}>

                                        <Grid row lg={12}>
                                            <Typography className={classes.labelText}>Status:</Typography>
                                        </Grid>

                                    </Grid>


                                    <Grid item lg={6}>
                                        <Grid row lg={12}>
                                            <Typography className={classes.valueText}>{lineDetails.isPrepaid ? 'Prepaid' : 'Postpaid'}</Typography>
                                        </Grid>

                                    </Grid>

                                    <Grid item lg={6}>

                                        <Grid row lg={12}>
                                            <Typography className={`${classes.valueText} ${classes.active}`}>
                                                <div className="statuses"><span className={
                                                    lineDetails.status === "Active" ? 'activeStatus' :
                                                        lineDetails.status === "Inactive" ? 'inActiveStatus' :
                                                            lineDetails.status === "Suspended" ? 'SuspendedStatus' :
                                                                lineDetails.status === "Disconnected" ? 'disconnectStatus' :
                                                                    lineDetails.status === "Hotlined" ? 'hotlineStatus' : ''

                                                }> {lineDetails.status}</span>
                                                </div>
                                            </Typography>
                                        </Grid>

                                    </Grid>

                                    <Grid item lg={6}>
                                        <Grid row lg={12}>
                                            <Typography className={classes.labelText}>Activated on:</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid item lg={6}>
                                        <Grid row lg={12}>
                                            <Typography className={classes.labelText}>Active Until:</Typography>
                                        </Grid>
                                    </Grid>


                                    <Grid item lg={6}>
                                        <Grid row lg={12}>
                                            <Typography className={classes.valueText}>{formatDate(lineDetails.activationDate)}</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid item lg={6}>
                                        <Grid row lg={12}>
                                            {lineDetails.deactivationDate ?
                                                <Typography className={classes.valueText}>{formatDate(lineDetails.deactivationDate)}</Typography>
                                                : '-'}
                                        </Grid>
                                    </Grid>


                                    <Grid item lg={6}>

                                        <Grid row lg={12}>
                                            <Typography className={classes.labelText}>ICC /SIM</Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid item lg={6}>
                                        <Grid row lg={12}>
                                            <Typography className={classes.labelText}>ESN / IMEI</Typography>
                                        </Grid>
                                    </Grid>


                                    <Grid item lg={6}>


                                        <Grid row lg={12}>
                                            <Typography className={classes.valueText}>{lineDetails.icc}</Typography>
                                        </Grid>


                                    </Grid>


                                    <Grid item lg={6}>



                                        <Grid row lg={12}>
                                            <Typography className={classes.valueText}>{lineDetails.esn}</Typography>
                                        </Grid>
                                    </Grid>

                                </Grid>


                            </Scrollbars>
                        </div>
                        {/* <div className={classes.footer}>

                        <div className={classes.footerRight}>

                            <CustomBtn id="save" size="medium" onClick={handleClose}  >Close</CustomBtn>

                        </div>
                    </div> */}
                    </div>
                </div>
            </Dialog >
        </>

    )
}

export default LineDetailsDialog